import { api } from "./api";

const userProductHardwareService = {
  // User methods
  submitHardwareId: async (productId, data) => {
    const response = await api.post(
      `/hardware/my-products/${productId}/hardware-id`,
      data
    );
    return response.data;
  },

  getMyHardwareIds: async () => {
    const response = await api.get("/hardware/my-hardware-ids");
    return response.data;
  },

  getHardwareIdForProduct: async (productId) => {
    const response = await api.get(
      `/hardware/my-products/${productId}/hardware-id`
    );
    return response.data;
  },

  // Admin methods
  getAllHardwareSubmissions: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(
      `/hardware/hardware-submissions${queryString ? `?${queryString}` : ""}`
    );
    return response.data;
  },

  confirmHardwareId: async (submissionId, approve, submission) => {
    const response = await api.put(
      `/hardware/hardware-submissions/${submissionId}/confirm`,
      {
        approve,
        expectedHardwareId: submission.hardware_id,
        expectedUpdatedAt: submission.updated_at,
      }
    );
    return response.data;
  },

  updateHardwareId: async (userId, productId, data) => {
    const response = await api.put(
      `/hardware/users/${userId}/products/${productId}/hardware-id`,
      data
    );
    return response.data;
  },

  getUserHardwareSubmissions: async (userId) => {
    const response = await api.get(
      `/hardware/users/${userId}/hardware-submissions`
    );
    return response.data;
  },
};

export { userProductHardwareService };
